import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, ButtonSwitchGroup } from '@ublend-npm/aulaui-core';
import setHomeViewRole from '@app/actions/home/setHomeViewRole.action';
import {
  HOME_VIEW_ROLE_LABELS,
  HOME_VIEW_ROLES,
  HomeViewRole,
} from '@app/constants/home';
import { getCanSwitchHomeViewRole, getHomeViewRole } from '@app/selectors/home';
import useBreakpoints from '@app/hooks/useBreakpoints';

const EducatorStudentToggle = () => {
  const dispatch = useDispatch();
  const activeRole = useSelector(getHomeViewRole);
  const canSwitch = useSelector(getCanSwitchHomeViewRole);

  if (!canSwitch) {
    return null;
  }

  const handleSelect = (role: HomeViewRole) => {
    if (role !== activeRole) {
      dispatch(setHomeViewRole(role));
    }
  };
  const { md } = useBreakpoints();

  const activeIndex = Math.max(HOME_VIEW_ROLES.indexOf(activeRole), 0);

  return (
    <Box sx={{ width: 152 }}>
      <ButtonSwitchGroup
        size={md ? 'medium' : 'small'}
        options={HOME_VIEW_ROLES.map((role) => HOME_VIEW_ROLE_LABELS[role])}
        activeIndex={activeIndex}
        onSelect={(index) => handleSelect(HOME_VIEW_ROLES[index])}
      />
    </Box>
  );
};

export default EducatorStudentToggle;
